import { css } from 'styled-components';
import { StyledPlaceHolderItem, StyledRow1, StyledRow2, StyledRow3, StyledRow4 } from './PlaceHolder.styles';
import { device } from '../breakpoints';
import { playGrey10 } from '../design-tokens';

export const getHeaderTextLayout = () => css`
    ${StyledPlaceHolderItem} {
        width: 100%;

        @media ${device.GteSmall} {
            max-width: 560px;
        }

        ${StyledRow1} {
            height: 31px;
            width: 60%;
            padding-bottom: 0;
            background-color: ${playGrey10};
            animation: none;

            @media ${device.GteSmall} {
                width: 150px;
            }
        }

        ${StyledRow2} {
            height: 15px;
            width: 100%;
            margin-top: 24px;
            background-color: ${playGrey10};
        }

        ${StyledRow3} {
            width: 100%;
            margin-top: 5px;
        }

        ${StyledRow4} {
            display: block;
            width: 80%;
            margin-top: 5px;
        }
    }
`;
